import React from "react";
import { TodayActivitiesTab } from "../TodayActivitiesTab/TodayActivitiesTab";
import { TodayActivitiesWrapper } from "./TodayActivitesStyle";

export const TodayActivities = () => {
  return (
    <TodayActivitiesWrapper className="mt-3">
      <TodayActivitiesTab />
    </TodayActivitiesWrapper>
  );
};
